import { Setting } from '../../../index';

const previewAnnex = {
  data() {
    return {
      isPreview: false,
      imgPath: Setting.getImgPath(),
      filePath: Setting.getFilePath(),
    };
  },
  methods: {
    // 预览附件图片
    // 预览附件文档类型文件
    previewFile(file) {
      console.log('%c [下载并预览附件]: ', 'color:#1989fa;', file);
      const { hash, note } = file;
      const url = `${this.filePath}${hash}/${note}`;
      console.log('%c [file url]: ', 'color:#1989fa;', url);

      uni.downloadFile({
        url,
        success(res) {
          console.log('%c [downloadFile res]: ', 'color:#1989fa;', res);
          /*wx.saveFile({
            tempFilePath: res.tempFilePath,
            success(res) {
              console.log('%c [下载成功]: ', 'color:#1989fa;', res);
            },
            fail(error) {
              console.log('%c [下载失败]: ', 'color:#1989fa;', error);
            },
          });*/
          uni.openDocument({
            filePath: res.tempFilePath,
            success() {
              console.log('%c [文件打开成功]: ', 'color:#1989fa;');
            },
            fail(error) {
              console.log('%c [文件打开失败]: ', 'color:#1989fa;', error);
              uni.showToast({
                title: '附件不支持预览',
                icon: 'none',
              });
            },
          });
        },
        fail(error) {
          // console.log('%c [附件下载失败]: ', 'color:#1989fa;', error);
          uni.showToast({
            title: '附件下载失败',
            icon: 'none',
          });
        },
      });
    },
    // 预览图片
    previewMultipleImage(index, images) {
      this.isPreview = true;
      const _images = JSON.parse(JSON.stringify(images));
      _images.forEach(item => {
        if (item.hash.indexOf('http://') === -1 && item.hash.indexOf('https://') === -1) {
          item.hash = this.imgPath + item.hash;
        }
      });
      const urls = _images.map(item => item.hash);
      uni.previewImage({
        current: index, // 当前显示图片的http链接/索引值
        urls, // 需要预览的图片http链接列表
      });
    },
  },
};
export default previewAnnex;
